module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-accept-c353245128ce149a96a39046cbfb8a2e.svg";